import { Component } from '@angular/core';

import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-logo',
    styleUrls: ['./logo.component.scss'],
    template: `
    <img src="{{ kpiLogoPath }}" class="capex-logo" alt="CAPEX intelligence">
  `,
    standalone: true,
})
export class LogoComponent {

  clientLogoPath: string = `assets/logos/${environment.logo}`;
  capexLogoPath: string = `assets/logos/capex.svg`;
  kpiLogoPath: string = `assets/logos/logo_kpi_no_bg.png`

}
